export default __webpack_public_path__ + "static/media/researcher.e5e4599b.png";